<script>

import NavBar from './NavBar.vue';
import LeftNavMenu from './LeftNavMenu.vue';
import CampaignResultsComponent from './CampaignResultsComponent.vue';

    export default {
    name: 'CampaignResultsPage',
    props: { titolo: String },
    //components: { NavBar, LeftNavMenu,LoginComponent }
    components: { NavBar, LeftNavMenu, CampaignResultsComponent }
}
</script>

<template lang="html">

        <body>
            <NavBar />
           <LeftNavMenu />
            <CampaignResultsComponent />
        </body>   
   
</template>
  
<style lang="css">

</style>